export default "__VITE_ASSET__Db7v6vGX__"